<template>
  <div class="partners-screen mb-20">
    <page-header :title="$t('app.partners.title')"/>
    <div class="row mt-30">
      <div class="col-sm-12 text-right mb-30">
        <base-button
          :title="$t(`app.partners.set_partner`)"
          :classNames="`btn btn-orange rounded pull-right`"
          @clicked="clickCreateAdmin"
        />
      </div>
      <div class="col-sm-12">
        <configurable-list
            :title="$t('app.tables.partnerAdmins.title')"
            :data="admins"
            :loadingText="loadingText"
            :fields="fields"
            @actionMade="userActionMade"
            @orderTable="orderTable"
          />
          <paginator
          :totalPages="totalPages"
          :currentPageIndex="currentPageIndex"
          @itemSelected="itemSelected"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import Paginator from '@/components/shared/navigations/Paginator';
import BaseButton from '@/components/shared/buttons/BaseButton';
import GenericForm from '@/components/shared/forms/GenericForm';
import PageHeader from '@/components/shared/layouts/PageHeader';
import ConfigurableList from '@/components/shared/lists/ConfigurableList';

export default {
  name: 'PartnersScreen',
  components: {
    Paginator,
    BaseButton,
    GenericForm,
    PageHeader,
    ConfigurableList,
  },
  props: {
  },
  data() {
    return {
      currentPageIndex: 1,
      totalPages: 0,
      admins: [],
      newUser: {
        name: undefined,
        partner_name: undefined,
        email: undefined,
        phone: undefined,
        job: undefined,
        role: 'admin',
      },
      editUser: {
        name: undefined,
        partner_name: undefined,
        email: undefined,
        phone: undefined,
        job: undefined,
        user_name: undefined,
        password: undefined,
        role: 'admin',
      },
      order: undefined,
      direction: undefined,
    };
  },
  created() {
    if (this.loggedInUser) {
      this.fetchAdmins({
        pageIndex: this.currentPageIndex,
         orderInfo: {
           order: this.order,
           direction: this.direction,
         },
      }).then((response) => {
        this.admins = response.users;
        this.totalPages = response.total_pages;
      });
    }
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'loggedInUser',
    }),
    loadingText() {
      if (this.admins.length === 0) {
        return this.$t('app.tasks.empty_list');
      }
      return this.$t('app.listLoading');
    },
    userAttributes() {
      return [
        {
          name: 'partner_name',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'name',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'job',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'email',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'phone',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'note',
          type: 'text-area',
          classes: 'col-md-12',
        },
      ];
    },
    userEditAttributes() {
      return [
        {
          name: 'partner_name',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'name',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'job',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'email',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'user_name',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'password',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'phone',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'note',
          type: 'text-area',
          classes: 'col-md-12',
        },
      ];
    },
    fields() {
      return [
        {
          title: this.$t('app.tables.partnerAdminTable.partner_name'),
          cellClass: 'partner-name-cell',
          key: 'partner_name',
          orderable: true,
        },
        {
          title: this.$t('app.tables.partnerAdminTable.name'),
          cellClass: 'name-cell',
          key: 'name',
          orderable: true,
        },
        {
          title: this.$t('app.tables.partnerAdminTable.email'),
          cellClass: 'email-cell',
          key: 'email',
        },
        {
          title: this.$t('app.tables.partnerAdminTable.phone'),
          cellClass: 'phone-cell',
          key: 'phone',
        },
        {
          title: this.$t('app.tables.global.actions'),
          isAction: true,
          cellClass: 'edit-cell',
          key: 'edit',
          class: 'zmdi zmdi-edit',
        },
        {
          title: '',
          isAction: true,
          cellClass: 'lock-cell',
          key: 'lock',
        },
        {
          title: '',
          isAction: true,
          cellClass: 'delete-cell',
          key: 'delete',
          class: 'zmdi zmdi-delete',
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      fetchAdmins: 'users/fetchAdmins',
      createNewUser: 'users/createUser',
      fetchUser: 'users/fetchUser',
      updateUser: 'users/updateUser',
      deleteUser: 'users/deleteUser',
    }),
    orderTable(payload) {
      this.order = payload.order;
      this.direction = payload.direction;
      this.fetchAdmins({
        pageIndex: this.currentPageIndex,
        orderInfo: {
          order: payload.order,
          direction: payload.direction,
        },
      }).then((response) => {
        this.admins = response.users;
        this.totalPages = response.total_pages;
      });
      
    },
    userActionMade(payload) {
      if (payload.actionType === 'edit') {
        this.fetchUser({
          id: payload.id,
        })
          .then((user) => {
            this.$eventBus.showModal({
              bind: {
                is: GenericForm,
                title: this.$t('app.partners.edit_partner'),
                fields: this.userEditAttributes,
                model: user,
                submitTitle: this.$t('app.users.buttons.save'),
                cancelTitle: this.$t('app.users.buttons.cancel'),
                modelName: 'administrator_users',
              },
              on: {
                submit: this.clickedUpdateUser,
              },
              width: '1000px',
            });
          })
          .catch((error) => {
            const mappedErrors = error.map(x => ` ${x}`);
            const errorMessages = this.$t('app.errors.general_validation', {
              message: mappedErrors,
            });
            this.$swal
              .fire({
                html: errorMessages,
                type: 'error',
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                focusConfirm: false,
              });
          });
      } else if (payload.actionType === 'delete') {
        this.$swal
          .fire({
            html: this.$t('app.notifications.general_confirm.title'),
            type: 'info',
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: this.$t('app.notifications.general_confirm.ok'),
            cancelButtonText: this.$t('app.notifications.general_confirm.cancel'),
          })
          .then((result) => {
            if (result.value) {
              this.deleteUser({
                userId: payload.id,
              })
                .then(() => {
                  this.$eventBus.showNotification({
                    notificationText: this.$t('app.users.success.delete'),
                    notificationType: 'success',
                  });
                  this.fetchAdmins({
                    pageIndex: this.currentPageIndex,
                    orderInfo: {
                      order: this.order,
                      direction: this.direction,
                    },
                  }).then((response) => {
                    this.admins = response.users;
                    this.userTotalPages = response.total_pages;
                  });
                })
                .catch((error) => {
                  this.$swal
                    .fire({
                      html: error,
                      type: 'error',
                      showCloseButton: true,
                      showCancelButton: false,
                      showConfirmButton: false,
                      focusConfirm: false,
                    });
                });
            }
          });
      } else if (payload.actionType === 'lock' || payload.actionType === 'unlock') {
        const partner_status = !payload.locked
        this.updateUser({
          userId: payload.id,
          params: {forbidden: partner_status},
        }).then(() => {
          this.$eventBus.showNotification({
            notificationText: this.$t('app.partners.success.update'),
            notificationType: 'success',
          });
          this.fetchAdmins({
              pageIndex: this.currentPageIndex,
              orderInfo: {
                order: this.order,
                direction: this.direction,
              },
            }).then((response) => {
            this.admins = response.users;
            this.$eventBus.hideModal();
          });
        })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
      }
    },
    clickedUpdateUser(user) {
      this.updateUser({
        userId: user.id,
        params: user,
      })
        .then(() => {
          this.$eventBus.showNotification({
            notificationText: this.$t('app.users.success.update'),
            notificationType: 'success',
          });
          this.fetchAdmins({
              pageIndex: this.currentPageIndex,
              orderInfo: {
                order: this.order,
                direction: this.direction,
              },
            }).then((response) => {
            this.admins = response.users;
            this.$eventBus.hideModal();
          });
        })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
    itemSelected(index) {
      this.currentPageIndex = index;
    },
    clickCreateAdmin() {
      this.$eventBus.showModal({
        bind: {
          is: GenericForm,
          title: this.$t('app.partners.set_partner'),
          fields: this.userAttributes,
          model: this.newUser,
          submitTitle: this.$t('app.users.buttons.save'),
          cancelTitle: this.$t('app.users.buttons.cancel'),
          modelName: 'administrator_users',
        },
        on: {
          submit: this.createUser,
          modalCanceled: this.resetNewUser,
        },
        width: '1000px',
      });
    },
    resetNewUser() {
      Object.assign(this.$data.newUser, this.$options.data().newUser);
    },
    createUser(newUser) {
      this.createNewUser({
        params: newUser,
      })
        .then((response) => {
          if (response.errors) {
            this.$eventBus.showNotification({
              notificationText: response.errors[0],
              notificationType: 'danger',
            });
            this.resetNewUser();
            this.$eventBus.hideModal();
            return;
          }
          this.$eventBus.showNotification({
            notificationText: this.$t('app.users.success.create'),
            notificationType: 'success',
          });
          this.fetchAdmins({
              pageIndex: this.currentPageIndex,
              orderInfo: {
                order: this.order,
                direction: this.direction,
              },
            }).then((userResponse) => {
            this.admins = userResponse.users;
            this.totalPages = userResponse.total_pages;
            this.resetNewUser();
            this.$eventBus.hideModal();
          });
        })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
  },
  watch: {
    currentPageIndex(newValue, oldValue) {
      this.fetchAdmins({
          pageIndex: newValue,
          orderInfo: {
            order: this.order,
            direction: this.direction,
          },
        }).then((response) => {
        this.admins = response.users;
        this.totalPages = response.total_pages;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.partners-screen {
  /deep/ .partner-name-cell {
    width: 15%;
  }
  /deep/ .name-cell {
    width: 15%;
  }
  /deep/ .email-cell {
    width: 30%;
  }
  /deep/ .phone-cell {
    width: 30%;
  }
  /deep/ .edit-cell {
    width: 5%;
  }
  /deep/ .delete-cell {
    width: 5%;
  }
  /deep/ .lock-cell {
    width: 5%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/partners/PartnersScreen.vue